import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { OutletModule } from '@spartacus/storefront';
import { PDPAuthGuard } from '../guards';
import { ShimanoProductSummaryComponent } from './shimano-product-summary.component';

@NgModule({
  declarations: [ShimanoProductSummaryComponent],
  imports: [CommonModule, OutletModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductSummaryComponent: {
          component: ShimanoProductSummaryComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [PDPAuthGuard],
        },
      },
    }),
  ],
  exports: [ShimanoProductSummaryComponent],
})
export class ShimanoProductSummaryModule {}
